import React from 'react';
import styled from 'styled-components';
import refinancingData from '../../api/refinancingData';
import refinancePerson from '../../icons/refinancePerson.png';
//

export default class RefinancePlan extends React.Component {
  state = {
    hovered: null,
  }

  handleHoverOn = (index) => (e) => {
    e.preventDefault();
    this.setState({ hovered: index });
  }

  handleHoveroff = (e) => {
    e.preventDefault();
    this.setState({ hovered: null });
  }

  render() {
    const { hovered } = this.state;
    const isHovered = (i) => i === hovered;

    return (
      <React.Fragment>
        <TimePlanContainer>
          {refinancingData.map((i, index) => (
            <TimeBox className='timeplan' key={i.id}>
              <Image src={i.icon} />
              <TimePointer isHovered={isHovered(index)}><p>{i.title}</p></TimePointer>
            </TimeBox>
          ))}
        </TimePlanContainer>
        <LineContainer>
          {refinancingData.map((i, index) => (
            <Box
              key={i.id}
              isHovered={isHovered(index)}
              onMouseEnter={this.handleHoverOn(index)}
              onMouseLeave={this.handleHoveroff}
            >
              <IconBox>
                <Image src={i.icon} />
              </IconBox>
              <TextBox>
                <h4>{i.title}</h4>
                <p>{i.text}</p>
              </TextBox>
            </Box>
          ))}
        </LineContainer>
      </React.Fragment>
    );
  }
}

const TimePointer = styled.div`
  width: 130px;
  height: 60px;
  position: relative;
  padding-left: 30px;
  margin-top: 12px;
  display: flex;
  align-items: center;
  background: ${(props) => (props.isHovered ? 'red' : '#ff5555')}

  &:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 0;
    border-left: 20px solid white;
    border-top: 30px solid transparent;
    border-bottom: 30px solid transparent;
  }
  &:before {
    content: "";
    position: absolute;
    z-index: 1;
    right: -20px;
    bottom: 0;
    width: 0;
    height: 0;
    border-left: 20px solid rgba(255,0,0,.6);
    border-left: ${(props) => (props.isHovered ? '20px solid red' : '20px solid #ff5555')}
    border-top: 30px solid transparent;
    border-bottom: 30px solid transparent;
  }
`;
const TimeBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all .2s ease;

  p {
    margin: 6px 0;
    font-size: 14px;
  }
`;


const TimePlanContainer = styled.div`
  padding: 30px 10px 60px 10px;
  display: flex;
  justify-content: space-between;
  max-width: 1300px;
  margin: 0 auto;

  @media(max-width: 1279px) {
    display: none;
  }
`;
const Image = styled.img`
  width: 50px;
  height: 50px;
`;
const Box = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 24px 0;
  width: 370px;

  @media(max-width: 400px) {
    width: 100%;
  }

  @media(max-width: 500px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`;

const LineContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  max-width: 1599px;
  margin: 24px auto 0 auto;

  background: url(${refinancePerson});
  background-repeat: no-repeat;
  background-position-x: left;
  background-size: contain;
  padding-left: 12%;

  // @media(min-width: 1555px){
  //   padding-left: 90px;
  // }

  @media(max-width: 1279px) {
    display: none;
  }
`;

const IconBox = styled.div`
  border: 2px solid ${({ theme }) => theme.palette.black.light};
  border-radius: 100px;
  padding: 12px;
  margin-right: 12px;
  width: 80px;
  height: 80px;
  @media(max-width: 500px) {
    margin - right: 0;
    margin-bottom: 24px;
  }
`;

const TextBox = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;

  h4 {
    margin: 0;
    padding-bottom: 6px;
  }

  p { margin: 0; width: 100%; }

  @media(max-width: 500px) {
    width: 100%;
    text-align: center;

    h4{
      margin: 0 auto;
    }
  }

`;
